import { useEffect, useState } from "react";
import Button from "../../components/Button/Button";
import "./SMHalfPageBrief.css";
import { Globals as OldGlobals } from "../../global/Globals";
import { fetchHalfPageBreif, fetchProposalReassign, fetchReassignDetails } from "../../services/api";
import { useNavigate } from "react-router-dom";
import NoResultsComponent from "../../components/NoResults/NoResult";
import Loader from "../../components/Loader/Loader";
import DocumentListItem from '../../components/HalfPage_Popup/DocumentListItem';
import { formatCurrency, formatDate } from "../../util/util";
import { useLanguage } from '../../context/Languagecontext';

export default function SMHalfPageBreif({
  responseData,
  togglePopup,
  screenType,
  popupShow
}) {
  const { Globals } = useLanguage();
  const navigate = useNavigate();
  const [BreifData, setBreifData] = useState([]);
  const [contentData, setContentData] = useState([]);
  const [proposalData, setProposalData] = useState([]);
  const [contentDataStatus, setContentDataStatus] = useState(null);
  const [data, setData] = useState([]);
  const [isExpand, setIsExpand] = useState(false);
  const [document, setDocument] = useState();
  const [reassignDetails, setReassignDetails] = useState([]);

  const [expandedIndexes, setExpandedIndexes] = useState([]);
  const screenName= screenType?.replace(/-/g, " ")?.toUpperCase()?.split(" ")?.join("_");
  const screenTypeName=Globals.REQUEST[`${screenName}`]
  const toggleExpand = (index) => {
    setExpandedIndexes((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index) 
        : [...prev, index] 
    );
  };

  const { proposalId, proposalDetailId } = responseData; 
  const getData = async () => {
    // console.log("screenType ===>",screenType);
    // const tabName=screenType.replace(/-/g, " ").toUpperCase().split(" ").join("_");
    // console.log("tabName",Globals.REQUEST[`${tabName}`]);
    try {
      console.log("Inside Try");
      switch (screenTypeName){ //(Globals.REQUEST[`${tabName}`]) {
        case Globals.REQUEST.BRIEF_RE_ASSIGN: {
          responseData = await fetchHalfPageBreif(
            OldGlobals.ENDPOINT.HALFPAGE_BRIEF,
            proposalId
          );
          const {
            countryName,
            productionTypeName,
            channelName,
            formatName,
            languageName,
            genreName,
            contentTypeName,
            clusterName,
            description,
            submissionRequirements,
            evalAndSelection,
            briefTypeName,
            ceEvalDeadline,
            smEvalDeadline,
            producers,
            createdByName,
            closingDate
          } = responseData.content;

          setContentData([
            { Description: description || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            { "Submission Requirements": submissionRequirements || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { "Evaluation Process": evalAndSelection || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
          ]);
          setBreifData([
            {name:Globals.TABLE_HEADERS.CREATEDBY, description: createdByName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            {name:Globals.CLOSING_DATE, description:closingDate? formatDate(closingDate): Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.UNSOLICITED_PROPOSAL_HALF.CHANNEL, description: channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.UNSOLICITED_PROPOSAL_HALF.FORMAT, description: formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.UNSOLICITED_PROPOSAL_HALF.COUNTRY, description: countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.UNSOLICITED_PROPOSAL_HALF.PRODUCTIONTYPE, description: productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.UNSOLICITED_PROPOSAL_HALF.SCRIPTED, description: contentTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.UNSOLICITED_PROPOSAL_HALF.GENRE, description: genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.UNSOLICITED_PROPOSAL_HALF.LANGUAGE, description: languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.UNSOLICITED_PROPOSAL_HALF.CLUSTER, description: clusterName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: Globals.BRIEF_TYPE, description: briefTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            { name: Globals.CE_EVALUATION_DEADLINE, description: ceEvalDeadline && formatDate(ceEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            { name: Globals.SM_EVALUATION_DEADLINE, description: smEvalDeadline && formatDate(smEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            { name: Globals.BRIEF_DATA_KEYS.PRODUCERS, description: producers.join(', ') || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            
            
          ]);
          setData([responseData?.content]);
          break;
        }
        case Globals.REQUEST.PROPOSAL_RE_ASSIGN: {
          responseData = await fetchProposalReassign(proposalId, proposalDetailId);
          const { title, logLine, episodeStructure,castInformation, synopsis, locationStudioInfo, brandIntegration, description, submissionRequirements,
            evalAndSelection, channelName, countryName, formatName, genreName, languageName, contentName, productionTypeName, documents,keyTeams,artistName,songName,episodeDuration,totalEpisodesDuration,noOfEpisodes,referenceLinks,currency,targetBudget } = responseData?.data?.content
          setContentData([
            { Description: description || "" },
            { "Submission Requirements": submissionRequirements || " " },
            { "Evaluation Process": evalAndSelection || " ", },
          ]);
          setBreifData([
            { name: "Country", description: countryName },
            { name: "Scripted / Non-Scripted", description: contentName },
            { name: "Genre", description: genreName },
            { name: "Channel", description: channelName },
            { name: "Language", description: languageName },
            { name: "Production Type", description: productionTypeName },
            { name: "Format", description: formatName },
            ...(formatName === Globals.UNSOLICITED_PROPOSAL.BIG_SERIES_MORE || formatName === Globals.UNSOLICITED_PROPOSAL.MINI_SERIES
              ? [
                  { name: "No. of Episodes", description: noOfEpisodes },
                  { name: "Episode Duration (in mins)", description: episodeDuration },
                  { name: "Total Duration (in mins)", description: totalEpisodesDuration },
                ]
              : [{ name: "Total Duration (in mins)", description: episodeDuration}])
          ]);
          
          setProposalData([
            { name: "Proposal Title", description: title },
            { name: "Synopsis", description: synopsis },
            { name: "Logline", description: logLine },
            { name: "Episode Structure and outline", description: episodeStructure || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
           // {name:'Currency',description:currency},
            { name: "Target Budget", description: currency +" "+targetBudget.toLocaleString() },
            { name: "Locations and Studio Information", description: locationStudioInfo || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            { name: "Cast and Presenter Information", description: castInformation || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: "Brand Integration Opportunities", description: brandIntegration || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            {name: "Project Status",description:""|| Globals.NA},
            {name: "Key Team", description: keyTeams},
            {name: "Artist Name", description: artistName ||Globals.NA},
            {name: "Song Name", description: songName || Globals.NA},
            {name:'Reference Links',description:referenceLinks || Globals.NA},


          ])

          setDocument([documents])

          setData([responseData?.data?.content]);
          break;
        }
        case Globals.REQUEST.BRIEF_SHELVE: {
          responseData = await fetchHalfPageBreif(
            OldGlobals.ENDPOINT.HALFPAGE_BRIEF,
            proposalId
          );
          const {
            countryName,
            productionTypeName,
            channelName,
            formatName,
            languageName,
            genreName,
            contentTypeName,
            clusterName,
            description,
            submissionRequirements,
            evalAndSelection,
            closingDate,
            createdByName,
            commisioningEditors
          } = responseData.content;
          setContentData([
            { Description: description || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            { "Submission Requirements": submissionRequirements || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            { "Evaluation Process": evalAndSelection || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
          ]);
          setBreifData([
            { name: "Channel", description: channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
            { name: "Country", description: countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: "Format", description: formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: "Genre", description: genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: "Scripted / Non-Scripted", description: contentTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name:"Cluster", description: clusterName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: "Language", description: languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: "Production Type", description: productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            { name: "Closing date", description: formatDate(closingDate) },
            { name: "Created By", description: createdByName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
            {name: "COMMISSIONING \n EDITIORS", description: commisioningEditors.join(", ")|| Globals.HALF_PAGE_BRIEF_DETAILS.NA}
          ]);
          setData([responseData?.content]);
          break;
        }
        default:
          throw new Error("Invalid activeTab");
      }
    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
      console.error("Error in App component:", error);
    }

  };

  useEffect(() => {
    const fetchData = async () => {
      let requestType;
      if (screenTypeName === Globals.REQUEST.BRIEF_SHELVE){
        requestType = 2;
      } else{
        requestType = 1;  //for other two tabs values need to be 1 (Globals.REQUEST.PROPOSAL_RE_ASSIGN,Globals.REQUEST.BRIEF_RE_ASSIGN)
      }
      try {
        const commonData = await fetchReassignDetails(proposalId,requestType);
        const content = commonData.data.content;
        setReassignDetails([
          { requestedBy: content.requestedBy || "" },
          { currentCluster: content.currentCluster || "" },
          { currentChannel: content.currentChannel  || "" },
          { reassignedCluster: content.reassignedCluster || "" },
          { reassignedChannel: content.reassignedChannel || "" },
          { comment: content.comment ||"" }
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Add appropriate dependencies.

    getData();
  }, [screenTypeName, proposalId]);

  const handleReload = () => {
    getData();
  };

  return (
    <div className="sm-Half-Page-Content">
      {renderHeader(data, togglePopup, reassignDetails,screenTypeName, Globals)}

      {data?.length > 0 ? (
        <>
          <div className="sm-halfscreen-scroll">
            {/* Re-assignment Details START */}
            {renderReassignDetails(reassignDetails, screenTypeName, Globals)}
            {/* Re-assignment Details END*/}

            {/*Request brief re-assign*/}
            {screenTypeName === Globals.REQUEST.BRIEF_RE_ASSIGN && (
              <>
                {renderBasicDetailPanelWithoutExpand(contentData, BreifData, proposalData, screenTypeName, document, expandedIndexes, toggleExpand, Globals)}
              </>
            )}

            {/*Request proposal re-assign*/}
            {screenTypeName === Globals.REQUEST.PROPOSAL_RE_ASSIGN && (
              <>
                {/*Solicited halfscreen disable partially*/}

                {/* {renderBasicDetailWithExpand(isExpand, setIsExpand, contentData, BreifData)} */}

                {/* Showing only UnSolicited halfscreen */}
                {renderBasicDetailPanelWithoutExpand(contentData, BreifData, proposalData, screenTypeName, document, expandedIndexes, toggleExpand, Globals)}
              </>
            )}

            {/*Request brief shelve*/}
            {screenTypeName === Globals.REQUEST.BRIEF_SHELVE && (
              <>
                {renderBasicDetailWithExpand(isExpand, setIsExpand, contentData, BreifData, Globals)}
              </>
            )}
          </div>

          {renderActionPanel(togglePopup, contentDataStatus, navigate, data, proposalId, popupShow, setIsExpand, screenTypeName, Globals)}
        </>

      ) : contentDataStatus?.length > 0 ? (
        renderNoData(handleReload, Globals)
      ) : (
        renderLoader()
      )}


    </div>
  );

}


function renderHeader(data, togglePopup, reassignDetails,screenTypeName, Globals) {
  let headerTitle 
  if(screenTypeName === Globals.REQUEST.BRIEF_RE_ASSIGN) {
    headerTitle = `Brief ${data[0]?.bRefNo} Re-assignment Approval`; 
  }else if(screenTypeName === Globals.REQUEST.PROPOSAL_RE_ASSIGN) {
    headerTitle = `Proposal ${data[0]?.propRefNo} Re-assignment Approval`;
  }else if(screenTypeName === Globals.REQUEST.BRIEF_SHELVE) {
    headerTitle = `Brief ${data[0]?.bRefNo} Shelve Approval`;
  }

  return <div className="sm-Half-Page-Header-Wrapper">
    {data && data?.length > 0 && (
      <div className="sm-Half-page-breif-header">
        {/* {`${data[0]?.bRefNo} ${reassignDetails[4]?.reassignedChannel} - ${data[0]?.formatName} `} */}
        {headerTitle}
      </div>
    )}
    <span
      className="HalfPage-close-icon HalfPage-close-icon-brief"
      onClick={togglePopup}
    >
      &times;
    </span>
  </div>;
}

/**
 * Render Basic detail panel with expand
 * @returns React.JSX.Element
 */

function renderBasicDetailWithExpand(isExpand, setIsExpand, contentData, BreifData, Globals) {
  return <div className="sm-HalfPage-proposal-unsolicated-briefs">
    <div className={`Half ${isExpand ? "active" : ""}`}>
      <div
        className="brief-expandable-header"
        onClick={() => {
          setIsExpand(!isExpand);
        }}
      >
        <label className="brief-accordion">{Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}</label>
        <img
          className="arrow"
          onClick={() => {
            setIsExpand(!isExpand);
          }}
          src={isExpand ? OldGlobals.IMG.ARROW_UP : OldGlobals.IMG.ARROW_DOWN}
          alt="toggle icon" />
      </div>
      {isExpand && (
        <div className="Half-Page-Content-Wrapper remove-mt">
          <div>
            {contentData?.map(
              (item, index) => Object.values(item)[0] && (
                <div key={index} className="Half-Page-Content-Wrapper">
                  <div
                    className={`${Object.keys(item)[0] === "Description"
                      ? "description-heading-sm"
                      : "small-heading"} Half-Page-Desc-header`}
                  >
                    {Globals.SOLICITED_BRIEFS[`${Object.keys(item)[0]}`]}
                  </div>
                  <p className="Half-Page-Description">
                    {Object.values(item)[0]}
                  </p>
                </div>
              )
            )}
          </div>
          <div>
            <div className="Half-Page-Form">
              {BreifData?.map((item, index) => (
                <div key={index} className="basic-detail-props">
                  <div className="heading">{Globals.BRIEF_DATA_KEYS[`${item.name.toUpperCase()}`]}</div>
                  <div className="description">{item.description}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  </div>;
}

/**
 * Render Basic detail panel without expand
 * @returns React.JSX.Element
 */
function renderBasicDetailPanelWithoutExpand(contentData, BreifData, proposalData, screenTypeName, document, expandedIndexes, toggleExpand, Globals) {
  const orderedItems = [];
  if (document && document[0]) {
    const allDocs = document[0]; 

    // handled only for unsolicited proposal
    const desiredOrder = ["PSH", "VP"];
    desiredOrder.forEach((docFor) => {
      const foundDoc = allDocs.find(
        (doc) => doc.documentFor === docFor
      );
      let heading = "";
      switch (docFor) {
        case "LBMB":
          heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.LBMB;
          break;
        case "PRSCH":
          heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
          break;
        case "SHWRL":
          heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.SHWRL;
          break;
        case "CPRC":
          heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.CPRC;
          break;
        case "RDOC":
          heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.RDOC;
          break;
        case "PSH":
          heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
          break;
        case "VP":
          heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.VP;
          break;
        default:
          heading = foundDoc?.documentType || "Document";
      }
      orderedItems.push({ foundDoc, docFor, heading, isDownload: false });
    });
  } else {
    console.error("no docs")
    // setFileItems([]);
  }
  return <>
    {/* Basic Details No-Expand START */}
    <div className="sm-HalfPage-pitch">
      <div className="sm-HalfPage-titleWrapper">
        <label className="brief-accordion">{screenTypeName === Globals.REQUEST.PROPOSAL_RE_ASSIGN ? Globals.PROPOSAL_DETAILS : Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}</label>
      </div>


      {proposalData?.length > 0 && screenTypeName === Globals.REQUEST.PROPOSAL_RE_ASSIGN ? (
        <div className="sm-Half-Page-Form">
          <div className="basic-detail-container">
            <div className="left-container">
            {BreifData?.map((item, index) => (
                <div key={index} className="basic-detail-props">
                                    {/* {console.log("jai shree ram")}
              {console.log("item.name", item.name)} */}
                  <div className="heading">{Globals.BRIEF_DATA_KEYS[`${item.name.toUpperCase()}`]}</div>
                  <div className="description">{item.description}</div>
                </div>
              ))}
              {proposalData?.map((item, index) => {
                const description = typeof item?.description === "string" ? item.description : ""; // Ensure description is a string
                const isExpanded = expandedIndexes?.includes(index);
                const words = description.split(" "); // Safely split the description
                const shouldShowMore = words.length > 20;
                const displayedDescription = isExpanded
                  ? description
                  : words.slice(0, 20).join(" ");


                return (
                  <div key={index} className="Half-Page-Content-Wrapper remove-mt">
                    <div className="test12345">
                      {(Globals.PROPOSAL_DETAILS_KEYS[`${item.name}`] === Globals.PROPOSAL_DETAILS_KEYS.TARGET_BUDGET || (Globals.PROPOSAL_DETAILS_KEYS[`${item.name}`] === Globals.PROPOSAL_DETAILS_KEYS.Currency)) ?
                        <div className="basic-detail-props custom-div-holder">
                          <div className="heading custom-heading">
                            {Globals.PROPOSAL_DETAILS_KEYS[`${item.name}`]}
                          </div>
                          <div className="description custom-description">
                            {displayedDescription}
                          </div>

                        </div> : <>
                          <div className="description-heading-sm Half-Page-Desc-header-SM mt-3">
                            {Globals.PROPOSAL_DETAILS_KEYS[`${item.name}`]}
                            {/* {Globals.UNSOLICITED_PROPOSAL_HALF[`${item.name.toUpperCase()}`]} */}
                          </div>
                          <div className="Half-Page-Description">
                            {displayedDescription}
                            {shouldShowMore && (
                              <span
                                className="sm-show-more-toggle mt-2"
                                onClick={() => toggleExpand(index)}
                              >
                                <br />
                                {isExpanded ? "View Less" : "View More"}
                              </span>
                            )}
                          </div>
                        </>
                      }
                    </div>
                  </div>
                )
              })}
            </div>
            <div className="right-container">
              <div className="Half-Page-Form">
                {orderedItems?.length > 0 ? (
                  <div>
                    {orderedItems?.map(({ foundDoc, docFor, heading }) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading} />)}
                  </div>
                ) : (
                  <p>{Globals.NA}</p>
                )}


              </div>
            </div>
          </div>
        </div>
      ) :
        <>
          {contentData?.map(
            (item, index) => Object.values(item)[0] && (
              <div
                key={index}
                className="Half-Page-Content-Wrapper remove-mt"
              >
                <div
                  className={`${Object.keys(item)[0] === "Description"
                    ? "description-heading-sm"
                    : "small-heading"} Half-Page-Desc-header`}
                >
                  {/* {Object.keys(item)[0]} */}
                   { Globals.SOLICITED_BRIEFS[`${Object.keys(item)[0]}`]}
                </div>
                <p className="Half-Page-Description">
                  {Object.values(item)[0]}
                </p>
              </div>
            )
          )}
          <div className="basic-details-container">
            {BreifData ? BreifData?.map((item, index) => (
              <div key={index} className="basic-detail-props">
                <div className="heading">{item.name}</div>
                <div className="description">{item.description}</div>
              </div>

            )) : ''}</div>
        </>}
    </div>
    {/* Basic Details No-Expand END */}
  </>;
}

/**
 * Render Action panel which will have all action button at bottom.
 * @returns React.JSX.Element
 */
function renderActionPanel(togglePopup, contentDataStatus, navigate, data, proposalId, popupShow, setIsExpand, screenTypeName, Globals) {

  //const addEditCluster = update ? 'UPDATE_CLUSTER':'ADD_NEW_CLUSTER'; // checking add/edit cluster
  let popStatus;
  switch (screenTypeName) {
    case Globals.REQUEST.BRIEF_RE_ASSIGN:
      popStatus = 'BRIEF_REASSIGN'
      break;
    case Globals.REQUEST.PROPOSAL_RE_ASSIGN:
      popStatus = 'PROPOSAL_REASSIGN'
      break;
    case Globals.REQUEST.BRIEF_SHELVE:
      popStatus = 'BRIEF_SHELVE'
      break;
    case Globals.REQUEST.USER_APPROVAL:
      popStatus = 'USER_APPROVAL'
      break;
  }
  return <div className="Half-Page-Close-Apply-Wrapper">
    <div className="Half-Page-Close-Apply-Brief">
      <div className="Half-Page-Close-Text-Brief" onClick={togglePopup}>
        {Globals.CLOSE}
      </div>
      {(contentDataStatus && contentDataStatus?.length > 0) || (
        <>
          <Button
            title={Globals.REQUEST.CTA_REJECT}
            id="cta_error"
            action={() => {
              popupShow({
                open: true,
                title: Globals[popStatus]?.REJECT_POPUP.TITLE1 + `${data?.[0]?.bRefNo}` + Globals[popStatus]?.REJECT_POPUP.TITLE2,
                toastMessage: Globals[popStatus]?.REJECT_POPUP.TOAST_SUCCESS,
                promptText: Globals[popStatus]?.REJECT_POPUP.PROMPT_TEXT,
                negativeActionText: Globals.REQUEST.CTA_REJECT,
                body: { proposalId: proposalId, updateFlag: 1 },

              })
              togglePopup()
            }}
          />
          <Button
            title={Globals.REQUEST.CTA_APPROVE}
            id="cta_success"
            action={() => {
              popupShow({
                open: true,
                title: Globals[popStatus]?.ARPPOVE_POPUP.TITLE1 + `${data?.[0]?.bRefNo}` + Globals[popStatus]?.ARPPOVE_POPUP.TITLE2,
                promptText: screenTypeName !== Globals.USER_APPROVAL ? Globals[popStatus]?.ARPPOVE_POPUP.PROMPT_TEXT : Globals[popStatus]?.ARPPOVE_POPUP.PROMPT_TEXT1 + 'name' + '\n' + Globals[popStatus]?.ARPPOVE_POPUP.PROMPT_TEXT2 + 'role',
                normalActionText: Globals.REQUEST.CTA_APPROVE,
                toastMessage: Globals[popStatus]?.ARPPOVE_POPUP.TOAST_SUCCESS,
                body: { proposalId: proposalId, updateFlag: 0 },

              })
              togglePopup()
            }}
          />
        </>
      )}
    </div>
  </div>;
}




/**
 * Render loader component
 * @returns React.JSX.Element
 */
function renderLoader() {
  return (
    <div className="NoResultsComponent" style={{ height: "80vh" }}>
      <Loader height={50} width={50} />
    </div>
  );
}

/**
 * Render if there is no result
 * @returns React.JSX.Element
 */
function renderNoData(handleReload, Globals) {
  return (
    <>
      <div className="No-Results-Wrapper">
        <NoResultsComponent
          data={{
            message: Globals.HALF_PAGE_MESSAGE,
            img: OldGlobals.IMG.HALF_PAGE_ERROR,
            submessage: Globals.HALF_PAGE_SUB_MESSAGE,
            className: "ErrorHeader",
            subclassName: "SubError",
            outerWrapper: "HalfPageWrapperHalfPageBrief",
            imgWrapper: "HalfPageBriefImg",
            button: "reload",
          }}
          handleReload={handleReload}
        />
      </div>
    </>
  );
}

function renderReassignDetails(reassignDetails, screenTypeName, Globals) {
  return (
    <div className="sm-HalfPage-pitch">
      <div className="sm-HalfPage-titleWrapper">
        <label className="brief-accordion">{screenTypeName=== Globals.REQUEST.BRIEF_SHELVE?Globals.SHELVE_DETAILS:Globals.RE_ASSIGNMENT_DETAILS}</label>
      </div>
      <div className="details-box mt-1">
        <p><span className="sm-Half-Page-Desc-header">{Globals.BRIEF_RE_ASSIGNMENT_DETAILS.REQUESTED_BY} {" "}</span> {reassignDetails[0]?.requestedBy}</p>
        {(screenTypeName !== Globals.REQUEST.BRIEF_SHELVE) &&
          (
            <div className="basic-detail-container-layout row mt-3">
              <div className="col-sm-6">
                <p><span className="sm-Half-Page-Desc-header">{Globals.BRIEF_RE_ASSIGNMENT_DETAILS.CURRENT_CLUSTER} {" "}</span> {reassignDetails[1]?.currentCluster}</p>
                <p><span className="sm-Half-Page-Desc-header">{Globals.BRIEF_RE_ASSIGNMENT_DETAILS.CURRENT_CHANNEL} {" "}</span> {reassignDetails[2]?.currentChannel}</p>
              </div>
              <div className="col-sm-6">
                <p><span className="sm-Half-Page-Desc-header">{Globals.BRIEF_RE_ASSIGNMENT_DETAILS.RE_ASSIGNED_CLUSTER} {" "}</span> {reassignDetails[3]?.reassignedCluster}</p>
                <p><span className="sm-Half-Page-Desc-header">{Globals.BRIEF_RE_ASSIGNMENT_DETAILS.RE_ASSIGNED_CHANNEL} {" "}</span> {reassignDetails[4]?.reassignedChannel}</p>
              </div>
            </div>
          )
        }
        <div className="mt-3">
          <div className="sm-Half-Page-Desc-header"> {Globals.BRIEF_RE_ASSIGNMENT_DETAILS.COMMENTS} {" "}</div>
          <div className="comments">{reassignDetails[5]?.comment}</div>
        </div>
      </div>
    </div>


  )
}
